import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import { encode } from "base-64";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
//import { status } from "../../../utlis/common.utlis";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";

const Page = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [categories, setCategory] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    //status: "",
    category: "",
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });
  const [dateType, setDateType] = useState("");

  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    console.log("Input Name:", name); // Debugging
    console.log("Input Value:", value); // Debugging
    console.log("Formatted Date:", formattedDate); // Debugging

    // Update the filters state
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [name]: date === null ? value : formattedDate,
      };
      return updatedFilters;
    });
  };

  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      search: filterParams.name,
      //status: filterParams.status,
      categoryid: filterParams.category,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.postedJobList}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setJobs(response.data.data.postedJob);
      setTotal(response.data.data.total);
    } else {
      setJobs([]);
    }
    setLoading(false);
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    // Clear all other date-related fields when selecting a new date_type
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const query = new URLSearchParams({
        page: pageNum,
        limit: LIMIT,
        /* search: filters.name,
        categoryid: filters.category,
        startDate: filters.startDate,
        endDate: filters.endDate,
        month: filters.month,
        quarter: filters.quarter,
        year: filters.year, */
      }).toString();

      setLoading(true);
      const response = await ApiService.getAPIWithAccessToken(`${api.postedJobList}?${query}`);
      if (response.data.status && response.data.statusCode === 200) {
        setJobs(response.data.data.postedJob);
        setTotal(response.data.data.total);
      } else {
        setJobs([]);
      }
      getCategoryList(api.categoryList);
      setLoading(false);
    };

    fetchData();
  }, [pageNum]);


  /* const getJobList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setJob(response.data.data.postedJob);
      setTotal(response.data.data.total);
    } else setJob([]);
    setLoading(false);
  }; */

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const handleSearch = () => {
    fetchFilteredData(filters); // Trigger search with current filters
  };

  const handleReset = () => {
    const resetFilters = {
      name: "",
      status: "",
      category: "",
      type: "",
      state_id: "",
      startDate: null,
      endDate: null,
      month: "",
      quarter: "",
      year: "",
    };

    setFilters(resetFilters);
    setDateType("");
    setPageNum(1);

    //console.log("Filters after Reset:", resetFilters);
    fetchFilteredData(resetFilters);
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h2 className="heading-title mb-2">Posted Job Opportunities</h2>
        </div>
        <div className="care-title-header">
          <div className="cc-search-filter wd100">
            <div className="row g-2">



              <div className="col-md-2">
                <div className="form-group dropdown-select">
                  <select
                    className="form-control"
                    name="category"
                    onChange={handleFilterChange}
                    value={filters.category || ""}
                  >
                    <option value="">Select Category</option>
                    {categories.length !== 0
                      ? categories.map((ele, indx) => {
                        return (
                          <option key={indx} value={ele.id}>
                            {ele.name ?? "NA"}
                          </option>
                        );
                      })
                      : null}
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    className="form-control ps-3"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleFilterChange}
                    name="name"
                    value={filters.name || ""}
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="date_type"
                    value={dateType}
                    onChange={handleDateTypeChange}
                  >
                    <option value="">Choose Date Range</option>
                    <option value="date">Date</option>
                    <option value="month">Month</option>
                    <option value="quarter">Quarter</option>
                    <option value="year">Year</option>
                  </select>
                </div>
              </div>

              {/* Conditionally Render Fields Based on Date Type */}
              {dateType === "date" && (
                <div className="col-md-4 d-flex">
                  <div className="form-group">
                    {/* From Date */}
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={filters.startDate}
                      onChange={(date) =>
                        handleFilterChange({ target: { name: "startDate" } }, date)
                      }
                      className="DatePicker-control"
                      isClearable
                      autoComplete="off"
                      placeholderText="From Date"
                    />
                  </div> &nbsp; &nbsp;
                  <div className="form-group">
                    {/* To Date */}
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={filters.endDate}
                      onChange={(date) =>
                        handleFilterChange({ target: { name: "endDate" } }, date)
                      }
                      className="DatePicker-control"
                      isClearable
                      autoComplete="off"
                      placeholderText="To Date"
                    />
                  </div>
                </div>
              )}

              {dateType === "month" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="month"
                        onChange={handleFilterChange}
                        value={filters.month}
                      >
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={handleFilterChange}
                        value={filters.year}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "quarter" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="quarter"
                        value={filters.quarter}
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">All Quarters</option>
                        <option value="1">Q1 (Jan - Mar)</option>
                        <option value="2">Q2 (Apr - Jun)</option>
                        <option value="3">Q3 (Jul - Sep)</option>
                        <option value="4">Q4 (Oct - Dec)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        value={filters.year}
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "year" && (
                <div className="col-md-2">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="year"
                      value={filters.year}
                      onChange={(e) => handleFilterChange(e)}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-md-2">
                <div className="form-group">
                  <button
                    className="btn btn-gr p-1"
                    onClick={handleSearch}
                  >
                    <i className="cc-input-group-text mdi mdi-magnify"></i>
                  </button> &nbsp;
                  <button
                    className="btn btn-re p-1"
                    onClick={handleReset}
                  >
                    <i className="cc-input-group-text mdi mdi-restore"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="cc-table-card">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th> Title </th>
                  <th> Job ID</th>
                  {/* <th> Job Details</th> */}
                  <th> Work Exp. </th>
                  <th> Salary </th>
                  <th> Work Timing </th>
                  <th> Status</th>
                  <th> View Job </th>
                  <th> Address</th>
                  <th> Posted Date & Time</th>
                  <th> View Profile</th>
                </tr>
              </thead>
              <tbody>
                {jobs.length !== 0 ? (
                  jobs.map((ele, indx) => {
                    return (
                      <tr key={indx}>
                        <td>{ele.title ?? "NA"}</td>
                        <td> {ele.job_id ?? "NA"} </td>
                        {/* <td>{ele.description ?? "NA"}</td> */}
                        <td>{ele.working_expirence + " Years" ?? "NA"}</td>
                        <td>
                          {ele.currency ?? "$"}
                          {ele.pay_range ?? "0"}/{ele.pay_range_type ?? ""}
                        </td>
                        <td>{ele.working_time_value ?? "NA"}</td>
                        <td>{ele.job_status ?? "NA"}</td>
                        <td>
                          <Link
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.jobOpportunityDetail, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <label
                              className="badge badge-gradient-success"
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa fa-eye"></i>
                            </label>
                          </Link>
                        </td>
                        <td className="text-capitalize">
                          {ele.address ?? "NA"}
                        </td>
                        <td>
                          {moment(ele.posted_date).format("MM-DD-yyyy hh:mm A")}
                        </td>
                        <td>
                          {ele.user_type === 1 ? (
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.userManagementDetail, {
                                  state: {
                                    id: encode(ele.userid),
                                  },
                                });
                              }}
                            >
                              <label
                                style={{ cursor: "pointer" }}
                                className="badge badge-gradient-success"
                              >
                                <i className="fa fa-eye"></i>
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.providerDetails, {
                                  state: {
                                    id: encode(ele.providerId),
                                  },
                                });
                              }}
                            >
                              <label
                                className="badge badge-gradient-success"
                                style={{ cursor: "pointer" }}
                              >
                                <i className="fa fa-eye"></i>
                              </label>
                            </Link>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="text-center">
                    <td colSpan="12">
                      <div>
                        <p>No posted jobs found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex align-items-center justify-content-center mt-3">
              {jobs.length !== 0 ? (
                <div className="care-table-pagination">
                  <ul className="care-pagination">
                    {pageNum !== 1 && (
                      <li
                        className="disabled"
                        id="example_previous"
                        onClick={() => setPageNum(pageNum - 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          Previous
                        </Link>
                      </li>
                    )}

                    {totalPageCalculator(total, LIMIT).length === 1
                      ? null
                      : totalPageCalculator(total, LIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                    {pageNum !== Math.ceil(total / LIMIT) && (
                      <li
                        className="next"
                        id="example_next"
                        onClick={() => setPageNum(pageNum + 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="7"
                          tabIndex="0"
                          className="page-link"
                        >
                          Next
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
